/* global modForm modUtils */
/**
 * Set Cookie with Heap Session ID
 * @param {String} resultsPage - getting final results page URL for cookie
 */
export function createHeapSessionIdCookie(resultsPage) {
	setTimeout(function() {
		if (modUtils.heapCookie) {
			modUtils.setCookie(
				modUtils.heapCookieData.sessionId,
				JSON.stringify({ initialTimestamp: modForm.getTime, resultsPage: resultsPage })
			);
		}
	}, 30);
}
